export enum AdminOrganizationConfigApiErrorTypes {
  CreateOrganizationConfigError,
  OrganizationConfigNotFoundError,
  DeleteOrganizationConfigError,
}

export class AdminOrganizationConfigApiError {
  constructor(public type: AdminOrganizationConfigApiErrorTypes, public error: Error) {}
}
